export default __webpack_public_path__ + "static/media/DD-Xpress-Delivery 1@2x.5772eabe.png";